// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bt-toast[data-v-1bf7e3f1]{background-color:#d33724}.billet-box[data-v-1bf7e3f1]{background:#e3eef9;border-radius:8px;padding:12px;height:40px}", ""]);
// Exports
module.exports = exports;
